import React from "react";
import SideNavigation from "@cloudscape-design/components/side-navigation";
import { useNavigate } from "react-router-dom";
import {ROUTES} from "src/constants";

const SideBar= () => {
    const navigate = useNavigate();

    return (
        <SideNavigation
            items={[
                { type: "link", text: "API Onboarding", href: ROUTES.API_ONBOARDING },
                { type: "link", text: "Service Onboarding", href: ROUTES.SERVICE_ONBOARDING },
            ]}
            onFollow={(event) => {
                event.preventDefault();
                navigate(event.detail.href);
            }}
        />
    );
};

export default SideBar;
